module.exports = {
	"authors": {}
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/authors.json
// module id = 1057
// module chunks = 0